export default {
    selectedvehicle(state) {
        return state.selectedvehicle;
    },
    selectedyear(state) {
        return state.selectedyear;
    },
    selectedmake(state) {
        return state.selectedmake;
    },
    selectedmodel(state) {
        return state.selectedmodel;
    },
    selectedengine(state) {
        return state.selectedengine;
    },
    selectedcategories(state) {
        return state.selectedcategories;
    },
    selectedgroups(state) {
        return state.selectedgroups;
    },
    selectedquestions(state) {
        return state.selectedquestions;
    },
    savedvehiclelist(state) {
        return state.savedvehiclelist;
    },
    newsavedvehicleadded(state) {
        return state.newsavedvehicleadded;
    },

    industry_sels(state){
        return state.industry_sels;
    },

    kit_vehicle(state) {
        return state.kit_vehicle;
    }
}